// TikTok IDs must remain strings: advertiser IDs exceed JS safe integers.
export function resolveTikTokAdvertiserId(campaign, result) {
  if (campaign?.destination?.toLowerCase() !== 'tiktok') return null;
  if (campaign.advertiser_id) return String(campaign.advertiser_id);
  const read = (value, depth = 0) => {
    if (!value || depth > 5) return null;
    if (typeof value === 'string') {
      try { return read(JSON.parse(value), depth + 1); } catch { return null; }
    }
    if (typeof value !== 'object') return null;
    if (typeof value.tiktok_url === 'string') {
      try {
        const url = new URL(value.tiktok_url);
        const id = url.searchParams.get('aadvid');
        if (url.protocol === 'https:' && url.hostname === 'ads.tiktok.com' && /^\d+$/.test(id || '')) return id;
      } catch { /* Missing or malformed launch URL is not an advertiser ID. */ }
    }
    for (const key of ['details', 'api_result', 'apiResult', 'json_response']) {
      const id = read(value[key], depth + 1);
      if (id) return id;
    }
    return null;
  };
  return read(result);
}
